import forOwn from 'mout/object/forOwn'

/**
 * Convert byItem scoring object to bySubtest scoring ubject
 * @param {object} byItem Created by initializeByItemScoring.
 * @returns {object} bySubtest initial object.
 */
export default function initializeBySubtestScoring(byItem) {
  let bySubtest = {}
  forOwn(byItem, (items, subTestId, obj) => {
    let possible = 0
    forOwn(items, (val, key, o) => {
      possible += val.possible
    })
    bySubtest[subTestId] = {
      complete: false,
      raw: 0,
      possible,
      percentage: 0,
      scale: 0,
    }
  })

  return bySubtest
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/initializeBySubtestScoring.js